import flagsmith from '@flagsmith/flagsmith';

export const getAllFeatureFlags = () => flagsmith.getState()?.flags || null;
